import ISourceMapSaveDataBody from "../../../../shared/contracts/ISourceMapSaveDataBody";

class CreateSourceMapService {

  static getSaveSourceMapDetailsBody = (
    createSourceMapForm: ISourceMapSaveDataBody
  ): any => {
    //CONSTANTS
 
    const EVERYONE_OWNER = "Everyone";


    const body = {
      ...createSourceMapForm,
    
     
      "owner": EVERYONE_OWNER,//TODO : need to remove from API
    };

    return body;
  };

}
export default CreateSourceMapService;
